import React from 'react';
import PropTypes from 'prop-types';

const Calendar = ({ month, day, bg }) =>
  <div className="calendar">
    <span className={`calendar-month ${bg && 'bg-' + bg}`}>{month}</span>
    <span className="calendar-day">{day}</span>
  </div>

Calendar.propTypes = {
  month: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  day: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default Calendar;